import { IConnectionRemap } from "./EdgeUtil";

export const openConfirmDialog = (question: string | IConnectionRemap, onConfirm: () => void) => {
  globalThis.confirmDialogQuestion = question;
  globalThis.confirmDialogOnConfirm = onConfirm;
  globalThis.setConfirmDialogVisibleState(true);
};
